import React, { useState, createContext } from 'react';

export const BusinessContext = createContext();
export const BusinessDispatcherContext = createContext();

function BusinessProvider({ children }) {
  const [state, setState] = useState({});

  return (
    <BusinessContext.Provider value={state}>
      <BusinessDispatcherContext.Provider value={setState}>
        {children}
      </BusinessDispatcherContext.Provider>
    </BusinessContext.Provider>
  );
}

export { BusinessProvider };
